import { queryAllHtmlElement } from '../../base/query-all-html-element';
import { OPTION_CHANGE_EVENT, type OptionChangeDetail } from './option-filter.types.ts';

type OptionFilterHostElement = HTMLElement & { value?: Set<string> };

export class OptionFilter {
  private el: {
    optionFilter: OptionFilterHostElement;
    toggle: HTMLElement | null;
    menu: HTMLElement | null;
    checkboxes: HTMLInputElement[];
  };

  public constructor(elOptionFilter: HTMLElement) {
    // identify HTML elements
    this.el = {
      optionFilter: elOptionFilter as OptionFilterHostElement,
      toggle: elOptionFilter.querySelector('.option-filter__toggle'),
      menu: elOptionFilter.querySelector('.option-filter__menu'),
      checkboxes: [...elOptionFilter.querySelectorAll('.option-filter__item__input')].filter(elCheckbox => elCheckbox instanceof HTMLInputElement),
    };

    this.bindEvents();
  }

  /**
   *
   */
  private bindEvents(): void {
    // bind events so clicking outside of the option filter closes the menu
    this.el.optionFilter.addEventListener('mousedown', (ev) => {
      ev.stopPropagation();
    });
    document.addEventListener('mousedown', () => {
      this.el.optionFilter.dataset['expanded'] = 'false';
      this.el.menu?.setAttribute('aria-expanded', 'false');
    });

    // toggle menu open/closed
    this.el.toggle?.addEventListener('click', () => {
      this.el.optionFilter.dataset['expanded'] = (this.el.optionFilter.dataset['expanded'] === 'false').toString();
      this.el.menu?.setAttribute('aria-expanded', (this.el.menu.getAttribute('aria-expanded') === 'false').toString());
    });

    // trigger option change event
    this.el.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (ev) => {
        if (!ev.currentTarget || !('value' in ev.currentTarget) || typeof ev.currentTarget.value !== 'string') {
          return;
        }

        const targetValue = ev.currentTarget.value;
        const currentValue = new Set([...this.el.checkboxes].filter(elCheckbox => elCheckbox.checked).map(elCheckbox => elCheckbox.value));
        const prevValue = new Set(currentValue);
        // calculate the previous value by adding or removing the value of the clicked checkbox from/to the current value
        prevValue.has(targetValue) ? prevValue.delete(targetValue) : prevValue.add(targetValue);

        // set the option filter element's value property to the calculated value to partially emulate an actual form field
        // TODO: don't make up properties on the fly like this. Store the value separately from the element, possibly in a lookup table.
        // - is this supposed to be setting the value to a Set?
        this.el.optionFilter.value = currentValue;

        // broadcast the change event
        const detail: OptionChangeDetail = { prevValue, currentValue };
        this.el.optionFilter.dispatchEvent(new CustomEvent<OptionChangeDetail>(OPTION_CHANGE_EVENT, { detail }));
      });
    });
  }
}

(() => {
  const onReady = () => {
    queryAllHtmlElement(document, '.option-filter').forEach(elOptionFilter => new OptionFilter(elOptionFilter));
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', onReady) : onReady();
})();
